import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CargoManifestForm from 'components/CargoManifestForm';

import { openBaseModal } from 'redux/modules/job-detail/effects';

import { getJobDetailData } from 'redux/modules/job-detail/selectors';

const CargoManifest = ({ item, params, openBaseModal }) => {
  if (!item) {
    return null;
  }

  const { stop_id, cargo_id } = params;
  const stop = stop_id && item.stops[stop_id];
  const cargoManifest = stop && stop.cargo_manifests[cargo_id];

  return (
    <CargoManifestForm
      open={true}
      stop={stop}
      cargoManifest={cargoManifest}
      journey={item}
      stopId={stop_id}
      onCreate={openBaseModal}
      onClose={openBaseModal}
    />
  );
};

CargoManifest.propTypes = {
  item: PropTypes.object,
  openBaseModal: PropTypes.func,
  params: PropTypes.object,
};

const actionCreators = {
  openBaseModal,
};

export default connect((state, props) => {
  return {
    item: getJobDetailData(state),
  };
}, actionCreators)(CargoManifest);
